<template>
	<ValidationObserver tag="form" novalidate class="social-login__form" @keyup="handleKeyUp" @submit.prevent="handleSignup">
		<CValidatedInput
			v-model.trim="name"
			vid="name"
			type="text"
			placeholder="Name"
			name="Name"
			rules="required"
			autofocus
		/>
		<CInput
			v-model="email"
			vid="email"
			:placeholder="email"
			disabled
			type="text"
			class="email-input mb-2"
		/>
		<CCreatePasswordInput v-model="password" />
		<CValidatedInput
			v-model="agreeToTerms"
			vid="agree-to-terms"
			type="checkbox"
			class="terms-of-use sz-2"
			name="Acceptance of Terms of Service and Privacy Policy"
			rules="accept-terms"
		>
			I agree to the <a href="/legal/terms" target="_blank" title="Agree to Terms of Service">Terms of Service</a> &amp; <a href="/legal/privacy" target="_blank" title="Agree to Privacy Policy">Privacy Policy</a>
		</CValidatedInput>
		<CStatusButton
			class="button button--primary text-4"
			title="Sign up for Cognito Forms"
			type="submit"
			status="default"
			:disabled="fieldsNotFilledOut"
		>
			Sign Up
		</CStatusButton>
	</ValidationObserver>
</template>
<script lang="ts">
	import { defineComponent, ref, computed } from 'vue';
	import CCreatePasswordInput from 'src/components/auth/CreatePasswordInput.vue';
	import CStatusButton from '@cognitoforms/shared-components/src/components/interaction/StatusButton.vue';
	import CValidatedInput from '@cognitoforms/shared-components/src/components/form-controls/ValidatedInput.vue';
	import { ValidationObserver, extend } from 'vee-validate';
	import type { PropType } from 'vue';
	import removeNonAlphaNumeric from 'src/utilities/removeNonAlphaNumeric';
	import CInput from '@cognitoforms/shared-components/src/components/form-controls/Input.vue';
	import type { DeviceVerificationResult } from '@cognitoforms/types/server-types/services/infrastructure/authentication/device-verification-result';

	extend('accept-terms', {
		validate: value => { return !!value; },
		message: 'You must agree to the Terms of Service and Privacy Policy.'
	});

	export default defineComponent({
		name: 'CUserSignup',
		components: {
			CCreatePasswordInput,
			CStatusButton,
			CValidatedInput,
			CInput,
			ValidationObserver
		},
		props: {
			authResult: {
				type: Object as PropType<DeviceVerificationResult>,
				default: () => {}
			},
			userEmail: { // to be used when props.authResult.email is null(prefilled from clicking on login)
				type: String,
				default: ''
			}
		},
		emits: ['signup'],
		setup(props, { emit }) {
			const email = ref<string>(props.userEmail || props.authResult.UserEmail || '');
			const name = ref<string>('');
			const password = ref<string>('');
			const agreeToTerms = ref<boolean>(false);

			const handleKeyUp = (e) => {
				// Auto-stripping name as user types it
				if (e.target.id === 'name')
					name.value = removeNonAlphaNumeric(name.value);
			};

			const handleSignup = () => {
				emit('signup', { email: email.value, name: name.value, password: password.value });
			};

			const fieldsNotFilledOut = computed<boolean>(() => {
				return !(email.value !== '' && name.value !== '' && password.value !== '' && agreeToTerms.value);
			});

			return {
				email,
				name,
				password,
				agreeToTerms,
				fieldsNotFilledOut,
				handleKeyUp,
				handleSignup
			};
		}
	});
</script>